import { el, clear } from '../../utils/dom.js';
import { Settings } from '../../api/resources.js';
import { ok, err } from '../../components/toast.js';
import { ponerTema } from '../../components/layout.js';

export default async function SettingsPage(outlet) {
  clear(outlet);
  outlet.appendChild(el('div', { class: 'page-head' }, el('h1', {}, 'Configuracion')));

  let map = {};
  try { map = await Settings.list(); }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  // Apariencia: la app, el catálogo y la página del contrato con el estilo de la empresa.
  const actual = map['app.tema']?.value || 'clasico';
  const selTema = el('select', { class: 'select', 'aria-label': 'Apariencia' },
    ...[['clasico', 'Clásica (violeta)'], ['navy', 'Blanco y azul navy (como la web)']].map(([v, t]) => {
      const o = el('option', { value: v }, t); if (v === actual) o.selected = true; return o; }));
  outlet.appendChild(el('div', { class: 'card mb-4' },
    el('h3', { class: 'rp-h' }, 'Apariencia'),
    el('p', { class: 'muted' }, 'Colores y letra de la app, del catálogo web y de la página donde el cliente firma.'),
    el('div', { class: 'flex gap-2 wrap mt-2' }, selTema,
      el('button', { class: 'btn primary', type: 'button', onclick: async () => {
        try {
          await Settings.bulk({ 'app.tema': { value: selTema.value, description: 'Apariencia: clasico | navy' } });
          ponerTema(selTema.value);
          ok('Apariencia guardada');
          SettingsPage(outlet);
        } catch (ex) { err(ex.message); }
      } }, 'Guardar apariencia'))));

  const card = el('div', { class: 'card' });
  card.appendChild(el('p', { class: 'muted' }, 'Edita los valores y guarda. Los valores son JSON (texto, numeros, booleanos, listas, objetos).'));

  const form = el('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      const updates = {};
      for (const key of Object.keys(map)) {
        const ta = form.querySelector(`textarea[name="${CSS.escape(key)}"]`);
        const desc = form.querySelector(`input[name="d_${CSS.escape(key)}"]`);
        let parsed;
        try { parsed = JSON.parse(ta.value); }
        catch { err(`Valor JSON invalido en "${key}"`); return; }
        updates[key] = { value: parsed, description: desc.value || undefined };
      }
      try { await Settings.bulk(updates); ok('Configuracion guardada'); }
      catch (ex) { err(ex.message); }
    },
  });

  const grid = el('div', { class: 'flex-col gap-4' });
  for (const [key, payload] of Object.entries(map).sort((a, b) => a[0].localeCompare(b[0]))) {
    const block = el('div', { style: 'border-bottom: 1px solid var(--border); padding-bottom: var(--sp-3);' },
      el('label', { class: 'text-bold text-mono' }, key),
      el('textarea', {
        name: key,
        class: 'textarea text-mono',
        rows: Array.isArray(payload.value) || typeof payload.value === 'object' ? 4 : 1,
        style: 'margin-top: 4px',
      }, JSON.stringify(payload.value, null, 2)),
      el('input', { name: `d_${key}`, class: 'input mt-2', placeholder: 'Descripcion', value: payload.description || '' }),
    );
    grid.appendChild(block);
  }
  form.appendChild(grid);
  form.appendChild(el('div', { class: 'flex justify-between mt-3' },
    el('span', { class: 'muted text-sm' }, `${Object.keys(map).length} valores`),
    el('button', { class: 'btn primary', type: 'submit' }, 'Guardar todo'),
  ));

  card.appendChild(form);
  outlet.appendChild(card);
}
